import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/authcontext';
import logoHeader from '../../assets/images/logo_header.png';
import { MdLocationOn, MdPhone, MdMenu, MdClose } from 'react-icons/md';
import './header.css';

const Header = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isMenuActive, setIsMenuActive] = useState(false);
  const headerContentRef = useRef(null);
  const headerTopRef = useRef(null);
  const { accessToken, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const windowScroll = window.pageYOffset;
      const topHeight = headerTopRef.current?.clientHeight || 0;
      setIsSticky(windowScroll > topHeight);
    };

    const handleResize = () => {
      const windowWidth = window.innerWidth;
      setIsMobile(windowWidth <= 1199);
      if (windowWidth > 1199) {
        setIsMenuActive(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    handleScroll();
    handleResize();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuActive(!isMenuActive);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const scrollToSection = (sectionId) => (event) => {
    event.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    if (isMobile) {
      setIsMenuActive(false);
    }
  };

  return (
    <header id="header">
      <div ref={headerTopRef} className="header_top">
        <div className="container d-flex" style={{ justifyContent: "space-between", alignItems: "center" }}>
          <div className="header_left">
            <span><MdLocationOn /> Ronak Puram Colony, Faizabad, Uttar Pradesh 224133</span>
            <span><MdPhone /> +91 8840766401, +91 9616152322</span>
          </div>
          <div className="header_right">
            {accessToken ? (
              <>
                <span className="login-register">
                  <span onClick={handleLogout} >Logout</span>
                </span>
              </>
            ) : (
              <span className="login-register">
                <Link to="/login">Login</Link>
                <Link to="/register">Register</Link>
              </span>
            )}
          </div>
        </div>
      </div>
      <div
        ref={headerContentRef}
        id="header_content"
        className={`header_content ${isSticky ? 'header-sticky' : ''} ${isMobile ? 'header_mobile' : ''}`}
      >
        <div className={`container ${isMobile ? 'header_mobile_container' : ''}`}>
          <div className="header_logo">
            <Link to="/"><img src={logoHeader} alt="Shri Ram International" /></Link>
          </div>
          <nav className={`header_menu ${isMobile ? 'mobile' : ''} ${isMenuActive ? 'active' : ''}`}>
            <ul className="menu">
              <li>
                <Link to="/" onClick={() => isMobile && setIsMenuActive(false)}>Home</Link>
              </li>
              <li>
                <a href="#about" onClick={scrollToSection('about')}>About</a>
              </li>
              <li>
                <a href="#gallery" onClick={scrollToSection('gallery')}>Gallery</a>
              </li>
              {accessToken && (
                <li>
                  <Link to="/bookings" onClick={() => isMobile && setIsMenuActive(false)}>My Bookings</Link>
                </li>
              )}
              <li>
                <Link to="/room" onClick={() => isMobile && setIsMenuActive(false)}>Book Now</Link>
              </li>
            </ul>
          </nav>
          {isMobile && (
            <button className={`menu-toggle ${isMenuActive ? 'active' : ''}`} onClick={toggleMenu}>
              {isMenuActive ? <MdClose /> : <MdMenu />}
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
